<div *ngIf="!browserInfo.isSupported">
  <td-message
    label="Unsupported Browser"
    sublabel="Please use Google Chrome, Mozilla Firefox, or Microsoft Edge for the best user experience and performance."
    color="warn"
    icon="warning"
  >
  </td-message>
  <pre style="display: none">
    {{ browserInfo | json }}
</pre
  >
</div>
